import {useSnackbar} from 'notistack';
import {DEFAULT_ERROR} from '../api/constants';
import {SnackbarVariants} from '../constants/constants';

export const useSnackbarHook = () => {
  const {enqueueSnackbar} = useSnackbar();

  const addSuccessToast = (message: string) => (
    enqueueSnackbar(message, {
      variant: SnackbarVariants.SUCCESS
    })
  );

  const addErrorToast = (message = DEFAULT_ERROR) => (
    enqueueSnackbar(message, {
      variant: SnackbarVariants.ERROR
    })
  );

  return {addSuccessToast, addErrorToast};
};
